import { render, staticRenderFns } from "./AdDtpCommentIcon.vue?vue&type=template&id=7de6883a&"
import script from "./AdDtpCommentIcon.vue?vue&type=script&lang=js&"
export * from "./AdDtpCommentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports